var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.8920865%",
    y1: "43.9585562%",
    x2: "56.1421442%",
    y2: "56.0101406%",
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15,
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161",
    stopOpacity: 0.01,
    offset: "85%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.0238420661%",
    y1: "50.002857%",
    x2: "100.02225%",
    y2: "50.002857%",
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.55,
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161",
    stopOpacity: 0.01,
    offset: "85%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.864 57.762L55 46.986 90.275 12H112m0 32.285H90.275l-8.138 8.072L93 63.133",
    fillOpacity: 0.8,
    fill: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0d47a1",
    d: "M82.137 73.905l8.138 8.072H112L93 63.133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42a5f5",
    d: "M71.3 63.138l10.847-10.762 10.847 10.76-10.847 10.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M82.146 73.897l10.847-10.76 1.514 1.502L83.66 75.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M82.137 73.905l16.12-5.524L93 63.13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNative);
export default __webpack_public_path__ + "static/media/Native.afc6c8ca145ace823ef8fed562e3fb62.svg";
export { ForwardRef as ReactComponent };